<template>
  <kt-datatable ref="datatable" v-bind="datatableProps"></kt-datatable>
</template>

<script>
import {StarShopApiUrl} from "@/common/api.service";
import { AuthorizationHeader } from "@/common/jwt.service";
import columns from './datatable/columns_factors';
import actionsColumn from './components/actions-column-factor.vue';

export default {
  name: 'FactorsWithManageAccess',
  props: {
    query: {
      type: Object,
      default: () => ({})
    }
  },
  computed: {
    datatableProps() {
      return {
        id: 'factorsWithManageAccess',
        data: {
          type: 'remote',
          source: {
            read: {
              url: StarShopApiUrl.path('factor/admin'),
              method: 'GET',
              headers: AuthorizationHeader,
              map: function(res) {
                return res.data.data;
              },
              params: {
                query: this.query
              },
            }
          },
          pageSize: 10,
          serverPaging: true,
          serverFiltering: true,
          serverSorting: true,
        },
        layout: {},
        pagination: false,
        sortable: true,
        columns: columns,
        actions: actionsColumn
      };
    }
  }
};
</script>